module.exports = __webpack_public_path__ + "img/bgfw6.3b5906cd.png";